import Base from '../Base';

export default class SettingBanner extends Base {
    static url = '/api/setting/banner';
}
